<template>
<div style="width: 100%">
	<v-card style="width: 100%">
		<v-data-table
			:headers="headers"
			:items="allPaymentsByUser"
			hide-actions
		>
			<template slot="items" slot-scope="props">
				<td>{{ props.item.id }}</td>
				<td>{{ props.item.created_at }}</td>
				<td>{{ props.item.worker.firstname }}</td>
				<td>{{ props.item.worker.lastname }}</td>
				<td>{{ $t('payments_types.type_' + props.item.type) }}</td>
				<td>{{ props.item.amount }}</td>
				<td>{{ props.item.comment }}</td>
				<td class="text-xs-center">
					<span v-if="props.item.type == 'salary'"></span>
					<v-icon v-else-if="props.item.salary_id" large color="green darken-2">done</v-icon>
					<v-icon v-else large color="blue darken-4">remove</v-icon>
				</td>
			</template>
		</v-data-table>
	</v-card>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { HEADERS_TABLE_WORKER_PAYS } from '../../constants'
import {localeHeadersWorkers} from "../../utils/helpers";

export default {
	components: { },
	props: {},
	data: (vm) => ({
		headers: localeHeadersWorkers(HEADERS_TABLE_WORKER_PAYS, vm.$t)
	}),
	computed: {
		allPaymentsByUser() {
			return this.$store.state.reports.allPaymentsByUser
		},
	},
	methods: {
	},
	watch: {
	}
}
</script>

<style>
.button-group {
	display: inline-block;
}
</style>
